import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

let popId = 0;
const listeners = new Set();
let queue = [];

export const popCredits = (amount, label = "credits") => {
  const id = ++popId;
  queue = [...queue, { id, amount, label }];
  listeners.forEach((cb) => cb(queue));
  setTimeout(() => {
    queue = queue.filter((p) => p.id !== id);
    listeners.forEach((cb) => cb(queue));
  }, 1800);
};

export const popXP = (amount) => popCredits(amount, "XP");

export const CreditPopOverlay = () => {
  const [pops, setPops] = useState([]);

  useEffect(() => {
    const cb = (list) => setPops([...list]);
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[9998] pointer-events-none flex items-center justify-center">
      <AnimatePresence>
        {pops.map((p, idx) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, scale: 0.5, y: 0 }}
            animate={{ opacity: 1, scale: 1, y: -80 - idx * 30 }}
            exit={{ opacity: 0, y: -160 - idx * 30, scale: 1.2 }}
            transition={{ duration: 1.6, ease: "easeOut" }}
            className="absolute"
          >
            <div className="bg-gradient-to-r from-[#FF6B35] to-[#7000FF] text-white font-bold text-lg px-5 py-2.5 rounded-full shadow-2xl flex items-center gap-2">
              <span className="text-xl">{p.amount > 0 ? "+" : ""}{p.amount}</span>
              <span className="text-xs uppercase tracking-wider opacity-90">{p.label}</span>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
